import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, DialogActions, Stack, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { useState } from 'react';

import { useBasicExitIntent } from '@/hooks/useBasicExitIntent';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const Popup5498 = () => {
  const [open, setOpen] = useState(false);

  useBasicExitIntent(() => {
    setOpen(true);
  });

  const handleClose = () => {
    sessionStorage.setItem('tzo-exit-intent', 'exit');
    setOpen(false);
  };

  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        />
        <DialogContent>
          <Box component="div" sx={{ textAlign: 'center', mt: 0 }}>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={{ xs: 1, sm: 2, md: 3 }}
              alignItems="center"
              justifyContent="space-around"
              sx={{
                px: { xs: 0, sm: 2 },
                display: 'flex',
                borderBottom: '1px solid #ccc',
              }}
            >
              <Box sx={{ textAlign: { xs: 'center', sm: 'center' } }}>
                <picture>
                  <img
                    src="/assets/images/wait-img.png"
                    loading="lazy"
                    alt="Wait! Don’t Miss Your 10% Discount!"
                    className="tab-responsive"
                    width={130}
                    height={106}
                  />
                </picture>
              </Box>
              <Box>
                <Typography
                  variant="body1"
                  color="primary"
                  sx={{
                    fontWeight: 700,
                    fontSize: { xs: 22, sm: 28, md: 30 },
                    color: '#da4b4b',
                    lineHeight: 1.2,
                    mb: 1,
                    textAlign: 'left',
                  }}
                >
                  Wait! Don’t Miss Your
                  <br />
                  <span style={{ color: '#333' }}> 10% Discount!</span>
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    textAlign: 'left',
                    fontSize: 14,
                    fontWeight: 500,
                    mb: 2,
                  }}
                >
                  Complete your{' '}
                  <span style={{ fontWeight: 600 }}>IRS Form 5498</span>{' '}
                  e-filing in minutes
                </Typography>
              </Box>
            </Stack>
            <Box
              component="ul"
              sx={{
                fontWeight: 500,
                fontSize: { xs: 16, sm: 16, md: 16 },
                mb: 0,
                textAlign: 'left',
                listStyleType: 'none',
                lineHeight: 1.4,

                '& li': { mb: 1.2, fontWeight: 600 },
              }}
            >
              <li> ✅ Fast, Secure, and IRS-Authorized E-Filing</li>
              <li>
                {' '}
                ✅ Pricing Starts at Just{' '}
                <b style={{ color: '#1da94a' }}>$2.49</b> per form
                <span style={{ fontSize: 14, fontWeight: '400' }}>
                  {' '}
                  (Bulk Rates as Low as{' '}
                  <b style={{ color: '#4269e2', fontSize: 14 }}>$0.59</b>)
                </span>
              </li>
              <li> ✅ Simple & Efficient Bulk Filing</li>
            </Box>
            <Typography
              gutterBottom
              variant="body1"
              sx={{
                fontWeight: 600,
                fontSize: { xs: 16, sm: 18, md: 20 },
                pt: 2,
                mb: 1,
                borderTop: '1px solid #ccc',
                lineHeight: 1.4,
                color: '#0a0a0aff',
              }}
            >
              {' '}
              🎉 Limited-Time{' '}
              <span style={{ fontWeight: 700, color: '#e73737ff' }}>
                {' '}
                Offer!
              </span>{' '}
            </Typography>
            <Typography
              gutterBottom
              variant="body1"
              sx={{
                fontWeight: 500,
                fontSize: { xs: 16, sm: 16, md: 18 },
                mb: 1,
                lineHeight: 1.4,
              }}
            >
              Use code{' '}
              <Box
                component="strong"
                sx={{
                  ml: 0,
                  color: '#c02121',
                  fontWeight: 600,
                  border: '2px dashed #20346f',
                  px: 1,
                  backgroundColor: 'rgb(255, 250, 205)',
                }}
              >
                TZOIR10
              </Box>{' '}
              at checkout to get <b>10% OFF</b> your filing fee.
            </Typography>
            <Typography variant="body1">
              {' '}
              E-file with TaxZerone – Fast, Easy, and Hassle-Free
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: 'center',
            py: '24px !important',
            textAlign: 'center',
            backgroundColor: '#e3e4e8',
          }}
        >
          <Box sx={{ px: { xs: 1, sm: 3 } }}>
            <Button
              variant="contained"
              size="large"
              className="btn-primary"
              sx={{ textTransform: 'none', display: 'inline-block' }}
              href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form5498`}
            >
              E-File Form 5498 Now
            </Button>
          </Box>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
};

export default Popup5498;
